const SERVICE = "market";

const getCategory = async (api, params) =>
  api.setMethod().get().setService(SERVICE).process("/b2c/categories", params);

// const getCategoryProduct = async (api, params) =>
//   api.setMethod().get().setService(SERVICE).process('/b2c/categories/', params);

const getCategoryProduct = async (api, categoryName, search) =>
  api
    .setMethod()
    .get()
    .setService(SERVICE)
    .process(`/b2c/categories/${categoryName}/products`);

const subCategory = async (api, categoryName) => {
  return api
    .setMethod()
    .get()
    .setService(SERVICE)
    .process(`/b2c/categories/${categoryName}?store_type=1`);
};
module.exports = {
  getCategory,
  getCategoryProduct,
  subCategory,
};
